<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-menu #menu [popup]="true" [model]="menuItems"></p-menu>

<p-table #pt [value]="propertyLeadProfiles" [columns]="cols" [lazy]="true" (onLazyLoad)="loadLazy($event)"
  dataKey="propertyLeadProfileId" [selectionMode]="'multiple'" [(selection)]="selectedProfiles" [loading]="loading"
  [paginator]="showPaginator()" [rows]="100" [rowsPerPageOptions]="[100,250,500,20000]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true" editable="true" editMode="cell"
  (onEditInit)="onCellEditInit($event)" (onEditComplete)="onCellEditComplete($event)"
  (onEditCancel)="onCellEditCancel()" [reorderableColumns]="true" (onColReorder)="onColReorder($event)">

  <!-- CAPTION -->
  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Property Leads</h1>
      <span>
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="reloadPage()">Clear Filters</button>

        <!-- New: Reset column order -->
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="resetColumnOrder()">Reset Columns</button>

        <button pButton pRipple class="p-button"
          style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">New Property Lead Profile +</button>

        <app-import-export importEnabled="false" [dataRetrived]="propertyLeadProfiles"
          (exportDataSelected)="exportSelected($event)" [columns]="columns" [importDisabled]="true">
        </app-import-export>
      </span>
    </div>
  </ng-template>

  <!-- HEADER -->
  <ng-template pTemplate="header" let-columns>
    <tr>
      <!-- Checkbox column: not reorderable -->
      <th pReorderableColumnDisabled style="width: 3rem; position: relative; overflow: visible;">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>

        @if (selectedProfiles?.length > 0) {
<span (click)="menu.toggle($event)" style="
            position: absolute;
            top: 38px;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            z-index: 1000;
          " title="Bulk Actions">
            <i class="pi pi-cog" style="font-size: 1.5rem; color: red;"></i>
          </span>
        }
      </th>

      <!-- Dynamic reorderable headers -->
      @for (col of columns; track trackByField($index, col)) {
        <!-- If sortable !== false, enable sorting; otherwise render plain header -->
        @if (col.sortable !== false) {
          <th pReorderableColumn [pSortableColumn]="col.field"
            [style.width]="col.field === 'listingStatus' ? '100px' : col.width || null"
            [style.minWidth]="col.field === 'listingStatus' ? '100px' : null"
            [style.maxWidth]="col.field === 'listingStatus' ? '100px' : null">
            {{ col.header }}
          </th>
        } @else {
          <th pReorderableColumn [style.width]="col.field === 'listingStatus' ? '100px' : col.width || null"
            [style.minWidth]="col.field === 'listingStatus' ? '100px' : null"
            [style.maxWidth]="col.field === 'listingStatus' ? '100px' : null">
            {{ col.header }}
          </th>
        }
      }

      <!-- Actions header: not reorderable -->
      <th pReorderableColumnDisabled></th>
    </tr>

    <!-- FILTER ROW (mirrors dynamic order) -->
    @if (showFilter) {
      <tr>
        <th pReorderableColumnDisabled></th>
        @for (col of columns; track trackByField($index, col)) {
          <th pReorderableColumn
            [style.width]="col.field === 'listingStatus' ? '50px' : col.width || null"
            [style.minWidth]="col.field === 'listingStatus' ? '50px' : null"
            [style.maxWidth]="col.field === 'listingStatus' ? '50px' : null">
            @switch (col.field) {
              <!-- Contact? / listingStatus -->
              @case ('listingStatus') {
                <p-multiSelect [options]="propertyLeadProfileService.listingStatuses" optionLabel="name"
                  optionValue="value" defaultLabel=""
                  (onChange)="pt.filter($event.value, 'listingStatus', 'in')" appendTo="body"
                  [style]="{ width: '50px', minWidth: '50px', maxWidth: '50px' }">
                </p-multiSelect>
              }
              <!-- Priority -->
              @case ('targetPriorityNum') {
                <p-multiSelect [options]="propertyLeadProfileService.targetPriorities" optionLabel="name"
                  optionValue="value" defaultLabel="Priority"
                  (onChange)="pt.filter($event.value, 'targetPriorityNum', 'in')" appendTo="body">
                </p-multiSelect>
              }
              <!-- Owners: no filter -->
              @case ('ownerLeadProfileSummaries') {
                <!-- intentionally empty -->
              }
              <!-- Default text filter -->
              @default {
                <input pInputText type="text" (input)="pt.filter($event.target.value, col.field, 'contains')"
                  [ngStyle]="{ width: '100%', minWidth: '50px' }" />
                }
              }
            </th>
          }
          <th pReorderableColumnDisabled></th>
        </tr>
      }
    </ng-template>

    <!-- BODY -->
    <ng-template pTemplate="body" let-row let-columns="columns">
      <tr>
        <!-- Checkbox: not reorderable -->
        <td pReorderableColumnDisabled>
          <p-tableCheckbox [value]="row"></p-tableCheckbox>
        </td>

        <!-- Dynamic reorderable cells matching header order -->
        @for (col of columns; track trackByField($index, col)) {
          <td pReorderableColumn
            [style.width]="col.field === 'listingStatus' ? '50px' : col.width || null"
            [style.minWidth]="col.field === 'listingStatus' ? '50px' : null"
            [style.maxWidth]="col.field === 'listingStatus' ? '50px' : null">
            @switch (col.field) {
              <!-- Editable dropdown for listingStatus -->
              @case ('listingStatus') {
                <div [pEditableColumn]="row" [pEditableColumnField]="'listingStatus'">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-dropdown [options]="propertyLeadProfileService.listingStatuses"
                        [(ngModel)]="row.listingStatus" optionLabel="name" optionValue="value"
                        placeholder="Status" [autoZIndex]="true" [style]="{ width: '100%' }"
                        appendTo="body">
                      </p-dropdown>
                    </ng-template>
                    <ng-template pTemplate="output">
									<span style="
                      display: inline-block;
                      max-width: 46px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      background-color: {{ getListingStatusObj(row)?.color }};
                      padding: 0 4px;
                      border-radius: 10px;
                    ">
                        {{ getListingStatusObj(row)?.name }}
                      </span>
                    </ng-template>
                  </p-cellEditor>
                </div>
              }
              <!-- Priority (editable; displays label on output) -->
              @case ('targetPriorityNum') {
                <div [pEditableColumn]="row" [pEditableColumnField]="'targetPriorityNum'">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-dropdown [options]="propertyLeadProfileService.targetPriorities"
                        [(ngModel)]="row.targetPriorityNum" optionLabel="name" optionValue="value"
                        placeholder="Priority" appendTo="body" [style]="{ width: '100%' }">
                      </p-dropdown>
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{ getTargetPriorityName(row?.targetPriorityNum) }}
                    </ng-template>
                  </p-cellEditor>
                </div>
              }
              <!-- Owners column: each owner stacked (Status pill, Name link, Date) -->
              @case ('ownerLeadProfileSummaries') {
                <div style="min-width:240px;">
                  @if (row.ownerLeadProfileSummaries?.length > 0) {
                    @for (o of row.ownerLeadProfileSummaries; track o) {
                      <div class="owner-block">
                        <span class="status-pill"
                          [ngStyle]="{ 'background-color': ownerLeadStatusMeta(o.leadStatus).color }">
                          {{ ownerLeadStatusMeta(o.leadStatus).label }}
                        </span><br>
                        <a [href]="'http://localhost:4201/owner-lead-profile-view/' + o.ownerLeadProfileId"
                          target="_blank" rel="noopener">
                          {{ o.lastName || ('#' + o.ownerLeadProfileId) }}
                        </a><br>
                        <small>{{ o.createDate | date:'MM-dd-yyyy HH:mm' }}</small>
                      </div>
                    }
                  } @else {
                    <span>&mdash;</span>
                  }
                </div>
              }
              <!-- Address as link to open form -->
              @case ('subjAdrStreet') {
                <a href="javascript:none" (click)="onOpenFormEdit(row)">{{ row.subjAdrStreet }}</a>
              }
              <!-- Default renderer -->
              @default {
                {{ row[col.field] }}
              }
            }
          </td>
        }

        <!-- Actions: not reorderable -->
        <td pReorderableColumnDisabled>
          <i class="pi pi-pencil" style="color:blue; font-size:110%; padding-right:20px;"
          (click)="onOpenFormEdit(row)"></i>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- BULK EDIT DIALOG -->
  <p-dialog header="Bulk Edit Fields" [(visible)]="showBulkUpdateDialog" [modal]="true" [closable]="true"
    [style]="{width: '50vw', maxWidth: '600px'}" [contentStyle]="{'max-height':'70vh', 'overflow':'auto'}">

    <div class="p-fluid row">
      <p-fieldset legend="Contact" [toggleable]="true">
        <div class="col-12">
          <div class="p-float-label w-100 mb-3">
            <p-dropdown id="listingStatus" [options]="propertyLeadProfileService.listingStatuses"
              optionLabel="name" optionValue="value" [(ngModel)]="bulkUpdateData.listingStatus"
            placeholder="Contact?" [autoZIndex]="true" [style]="{maxWidth: '225px'}"></p-dropdown>
            <label for="listingStatus">Contact?</label>
          </div>
        </div>

        <div class="col-12">
          <div class="p-float-label w-100 mb-3">
            <p-dropdown id="targetPriorityNum" [options]="propertyLeadProfileService.targetPriorities"
              optionLabel="name" optionValue="value" [(ngModel)]="bulkUpdateData.targetPriorityNum"
            placeholder="Priority" appendTo="body" [style]="{maxWidth: '225px'}"></p-dropdown>
            <label for="targetPriorityNum">Priority</label>
          </div>
        </div>
      </p-fieldset>

      <p-fieldset legend="Subject Property" [toggleable]="true" [collapsed]="false">
        <div class="row">
          <div class="col-12">
            <div class="p-float-label">
              <input id="subjAdrDevelopmentName" type="text" pInputText
                [(ngModel)]="bulkUpdateData.subjAdrDevelopmentName" />
                <label for="subjAdrDevelopmentName">Development</label>
              </div>
            </div>
            <div class="col-12">
              <div class="p-float-label">
                <input id="subjAdrStreet" type="text" pInputText [(ngModel)]="bulkUpdateData.subjAdrStreet" />
                <label for="subjAdrStreet">Address</label>
              </div>
            </div>
            <div class="col-6">
              <div class="p-float-label">
                <input id="subjAdrCity" type="text" pInputText [(ngModel)]="bulkUpdateData.subjAdrCity" />
                <label for="subjAdrCity">City</label>
              </div>
            </div>
            <div class="col-2">
              <div class="p-float-label">
                <input id="subjAdrState" type="text" pInputText [(ngModel)]="bulkUpdateData.subjAdrState" />
                <label for="subjAdrState">State</label>
              </div>
            </div>
            <div class="col-4">
              <div class="p-float-label">
                <input id="subjAdrPostalCode" type="text" pInputText
                  [(ngModel)]="bulkUpdateData.subjAdrPostalCode" />
                  <label for="subjAdrPostalCode">Zip</label>
                </div>
              </div>

              <div class="col-4">
                <div class="p-float-label">
                  <input id="subjAdrDistrict" type="text" pInputText
                    [(ngModel)]="bulkUpdateData.subjAdrDistrict" />
                    <label for="subjAdrDistrict">District</label>
                  </div>
                </div>

                <div class="col-4">
                  <div class="p-float-label">
                    <input id="subjAdrRegion" type="text" pInputText [(ngModel)]="bulkUpdateData.subjAdrRegion" />
                    <label for="subjAdrRegion">Region</label>
                  </div>
                </div>
                <div class="col-4">
                  <div class="p-float-label">
                    <p-dropdown id="subjAdrCountry" [options]="countries"
                      [(ngModel)]="bulkUpdateData.subjAdrCountry" optionLabel="name" appendTo="body"
                      optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
                      placeholder="Country">
                    </p-dropdown>
                    <label for="subjAdrCountry">Country</label>
                  </div>
                </div>
              </div>
            </p-fieldset>

            <p-fieldset legend="Mailing Address" [toggleable]="true" [collapsed]="false">
              <div class="col-4">
                <div class="p-float-label">
                  <p-dropdown id="mailAdrCountry" [options]="countries" [(ngModel)]="bulkUpdateData.mailAdrCountry"
                    optionLabel="name" appendTo="body" optionValue="abbr" [filter]="true" filterBy="name"
                    [showClear]="false" placeholder="Country">
                  </p-dropdown>
                  <label for="mailAdrCountry">Country</label>
                </div>
              </div>
            </p-fieldset>
          </div>

          <div class="p-dialog-footer">
            <button pButton type="button" label="Close" (click)="showBulkUpdateDialog = false"
            class="p-button-outlined"></button>
            <button pButton type="button" label="Apply to Selected" (click)="confirmBulkUpdate()" class="p-button-primary"
            [disabled]="!selectedProfiles?.length"></button>
          </div>
        </p-dialog>
